import React from 'react';
import { Justify } from 'ksnm-common-ui/lib/Table2/Table.interface';
import { ORDER } from 'ksnm-common-ui/lib/Table2/utils/TableRequest';
import { FILTER } from 'ksnm-common-ui/lib/Table2/utils/TableRequest/TableRequest.interface';
import { Tooltip } from 'ksnm-common-ui/lib/Tooltip';
import type { CellValue, ColumnInterface, DataSourceRow, RenderParam } from 'ksnm-common-ui/lib/Table2/Table.interface';

import { dataControlStore } from '@stores/dataControlStore';

import { ReportVersionCell } from '../ControlLevel/ReportVersionCell';
import { Status } from '../Status';

import styles from '../DataControl.module.scss';

const onClick = (data: DataSourceRow) => {
  const { addBreadcrumbs, addPage, setFilters } = dataControlStore;

  setFilters({ runNumber: data.exec_num as string }, 'controlLevel');
  addBreadcrumbs([data.ctrl_vers as string]);
  addPage([
    {
      controlType: 'controlLevel',
      reportPackageCodeCm: data.report_package_code_cm as string,
      filters: [
        [
          {
            name: 'report_package_code_cm',
            type: FILTER.EQ,
            values: [data.report_package_code_cm as string],
            filterIsInverted: false,
          },
          {
            name: 'ctrl_vers',
            type: FILTER.EQ,
            values: [data.ctrl_vers as string],
            filterIsInverted: false,
          },
        ],
      ],
    },
  ]);
};

export const columns: ColumnInterface[] = [
  {
    key: 'ctrl_group_order',
    hidden: true,
    orderBy: {
      type: ORDER.ASC,
      order: 1,
      isNullsFirst: false,
    },
  },
  {
    title: 'Группа контролей',
    key: 'ctrl_group_out',
    width: 200,
  },
  {
    title: 'Технический код контроля',
    key: 'ctrl_vers',
    width: 180,
    orderBy: {
      type: ORDER.ASC,
      order: 2,
      isNullsFirst: false,
    },
    render: ({ data, value }) => (
      <div onClick={() => onClick(data)} className={styles.link}>
        {value}
      </div>
    ),
  },
  {
    title: 'Код контроля',
    key: 'ctrl_vers_ext',
    width: 200,
  },
  {
    title: 'Наименование контроля',
    key: 'ctrl_name',
    width: 500,
    render: ({ value, data }) => (
      <Tooltip content={data.ctrl_vers_desc} hideOnClick={false}>
        <span>{value}</span>
      </Tooltip>
    ),
  },
  {
    title: 'Период выполнения КП',
    key: 'period_kp',
    width: 250,
    justify: Justify.CENTER,
  },
  {
    title: 'Порядковый номер запуска КП',
    key: 'exec_num',
    width: 180,
    orderBy: {
      type: ORDER.DESC,
      order: 3,
      isNullsFirst: false,
    },
  },
  {
    title: 'Статус',
    key: 'status_out',
    width: 250,
    justify: Justify.CENTER,
    render: ({ data, value }) => (
      <Status status={data.status_type}>
        <div onClick={() => onClick(data)} className={styles.link}>
          {value}
        </div>
      </Status>
    ),
  },
  {
    title: 'Описание результата',
    key: 'text_out',
    width: 400,
    justify: Justify.CENTER,
  },
  {
    title: 'Дата и время выполнения КП',
    key: 'date_kp',
    width: 250,
    justify: Justify.CENTER,
  },
  {
    title: 'Пользователь',
    key: 'user_kp',
    width: 300,
    justify: Justify.CENTER,
  },
  {
    title: 'Сравниваемые отчеты',
    key: 'reports_all_text',
    width: 250,
    render: ({ value, data }: RenderParam): CellValue => {
      if (Array.isArray(data.reports_all)) {
        return (
          <>
            {data.reports_all?.map((item, idx) => (
              <>
                <ReportVersionCell key={idx} dataRow={item} content={item.report_text}>
                  <span className={styles.link}>{item.report_code_ext}</span>
                </ReportVersionCell>
                {Array.isArray(data.reports_all) && idx != data.reports_all?.length - 1 ? ', ' : ''}
              </>
            ))}
          </>
        );
      }

      return value;
    },
  },
  {
    key: 'report_package_code_cm',
    hidden: true,
  },
  {
    key: 'status_type',
    hidden: true,
  },
  {
    key: 'ctrl_vers_desc',
    hidden: true,
  },
  {
    key: 'reports_all',
    hidden: true,
  },
  {
    key: 'is_last_run',
    hidden: true,
  },
];
